export const SWITCH_CHAT_DIALOG = "SWITCH_CHAT_DIALOG";
export const GET_MESSAGES = "GET_MESSAGES";
export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const GET_CUSTOMER_CHATS = "CET_CUSTOMER_CHATS";
export const GET_CUSTOMER_CHAT = "CET_CUSTOMER_CHAT";
export const GET_CHAT_MESSAGES = "GET_CHAT_MESSAGES";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const CREATE_NEGOTIATION = "CREATE_NEGOTIATION";
export const UPDATE_NEGOTIATION = "UPDATE_NEGOTIATION";